import { Divider, IconButton, InputAdornment, InputBase, Paper, TextField } from "@mui/material";
import { ButtonType } from "../../../Utilities/Enums/ButtonTypeEnum";
import { SearchOffOutlined, SearchOutlined } from "@mui/icons-material";
import styled from "styled-components";
import { lazy, useEffect, useRef, useState } from "react";
import { retryLazyImport } from "../../../Store/SessionManager";
import { IconAdjustmentsHorizontal, IconSearch } from "@tabler/icons-react";
import CustomIconButton from "../CustomIconButton";
import { GlobalConstants } from "../../../Constants/GlobalConstants";
import LocalStorageHelper from '../../../Utilities/Helpers/LocalStorageHelper';

const CustomButton = lazy(() => retryLazyImport(() => import("../CustomButton")));

const SearchContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: min-context;
    gap: 10px;
    // margin-bottom: 15px;
    align-items: center;

    .MuiOutlinedInput-input.MuiInputBase-input {
    padding: 5px 14px !important;
}
`

const CustomSearchField = (props: { searchValue: string, placeholder: string, onChangeSearch: (srch: string) => void }) => {
    let isDarkMode = LocalStorageHelper.isDarkMode();

    const [searchString, setSearchString] = useState("");

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchString(e.target.value)
        const delayDebounceFn = setTimeout(() => {
            props.onChangeSearch(e.target.value)
        }, 1000)
        return () => clearTimeout(delayDebounceFn)
    };

    useEffect(() => {
        setSearchString(props.searchValue)
    }, [props.searchValue])

    return <Paper component="form"
        sx={{
            fontSize: GlobalConstants.DEFAULT_FONT_SIZE,
            m: '10px',
            padding: '2px 5px',
            display: 'flex', alignItems: 'center',
            width: 450,
            borderRadius: '4px', //'30px',
            background: 'none',
            border: `1px solid ${(isDarkMode ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)')}`
            // border: '1px solid var(--fieldFocusedBorderPrimaryColor)'
        }}
        elevation={0}>
        <InputBase
            value={searchString}
            startAdornment={(
                <InputAdornment position="start" sx={{marginRight: '10px'}}>
                    <IconSearch size={18} />
                </InputAdornment>
            )}
            sx={{ ml: 1, flex: 1 }}
            placeholder={props.placeholder}
            inputProps={{ 'aria-label': 'search google maps' }}
            onChange={handleChange}
        />
        </Paper>
}

export default CustomSearchField;